import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "playground pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_RunButton = _resolveComponent("RunButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputTextarea, {
      value: _ctx.prompt,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prompt) = $event)),
      placeholder: 'Input prompt',
      class: "w-full mt-8 p-1",
      rows: 5
    }, null, 8, ["value"]),
    _createVNode(_component_RunButton, {
      onRun: _ctx.run,
      showKeyDescription: _ctx.showKeyDescription,
      disabled: !_ctx.prompt || _ctx.isLoading,
      isLoading: _ctx.isLoading
    }, null, 8, ["onRun", "showKeyDescription", "disabled", "isLoading"]),
    (_ctx.result)
      ? (_openBlock(), _createBlock(_component_InputTextarea, {
          key: 0,
          value: _ctx.result,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result) = $event)),
          label: 'Result:',
          disabled: "",
          class: "mt-4 w-full p-1",
          rows: 5
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}